/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_EtafInputs */

const en_nav_etaf = /** @type {(inputs: Nav_EtafInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-TAF`)
};

/**
* | output |
* | --- |
* | "e-TAF" |
*
* @param {Nav_EtafInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_etaf = /** @type {((inputs?: Nav_EtafInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_EtafInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_etaf(inputs)
});